const normalizeValue = value => `${value || ''}`.toLowerCase().replace(/[_\s]+/g, '-').trim();

const getPlanFamilyFromValue = value => {
	const normalizedValue = normalizeValue(value);

	if (
		normalizedValue.includes('studio') ||
		normalizedValue.includes('subuser') ||
		normalizedValue.includes('seat')
	) {
		return 'studio';
	}
	if (normalizedValue.includes('vip') || normalizedValue.includes('plus')) return 'vip';
	if (
		normalizedValue.includes('individual') ||
		normalizedValue.includes('standard') ||
		normalizedValue.includes('on-demand-individual')
	) {
		return 'individual';
	}

	return '';
};

const getBillingCycleFromValue = value => {
	const normalizedValue = normalizeValue(value);

	if (!normalizedValue) return '';
	if (
		normalizedValue.includes('year') ||
		normalizedValue.includes('annual') ||
		normalizedValue.includes('annually')
	) {
		return 'yearly';
	}
	if (
		normalizedValue.includes('month') ||
		normalizedValue.includes('monthly')
	) {
		return 'monthly';
	}

	return '';
};

const getSeatCountFromValue = value => {
	const normalizedValue = normalizeValue(value);
	const seatMatch = normalizedValue.match(/(?:^|[^0-9])(5|10)(?:-seats?|[^0-9]|$)/);
	return seatMatch ? Number(seatMatch[1]) : null;
};

export const getCurrentSubscriptionProfile = details => {
	if (!details) {
		return {
			family: '',
			billingCycle: '',
			seatCount: null
		};
	}

	const planCandidates = [
		details.planId,
		details.planName,
		details.itemName,
		details.currentPlanName,
		details.planLabel,
		details.plan
	];
	const billingCandidates = [
		details.billingFrequency,
		details.billingPeriodLabel,
		details.billingPeriodUnit,
		details.billingPeriod,
		details.planPeriod
	];

	const familySource = planCandidates.find(candidate => getPlanFamilyFromValue(candidate)) || '';
	const billingSource =
		billingCandidates.find(candidate => getBillingCycleFromValue(candidate)) ||
		planCandidates.find(candidate => getBillingCycleFromValue(candidate)) ||
		'';
	const seatSource = planCandidates.find(candidate => getSeatCountFromValue(candidate) !== null) || '';

	return {
		family: getPlanFamilyFromValue(familySource),
		billingCycle: getBillingCycleFromValue(billingSource),
		seatCount: getSeatCountFromValue(seatSource)
	};
};

export const getDisplayedPlanProfile = (plan, activePlan) => {
	const familySource = activePlan?.cbItem || activePlan?.seatId || plan?.cbItem || plan?.id || plan?.title;
	const billingSource = plan?.id || activePlan?.cbItem || plan?.cbItem || activePlan?.seatId;
	const seatSource = activePlan?.seatId || activePlan?.cbItem || plan?.id;

	return {
		family: getPlanFamilyFromValue(familySource),
		billingCycle: getBillingCycleFromValue(billingSource),
		seatCount: getSeatCountFromValue(seatSource)
	};
};

export const isMatchingCurrentPlan = ({ currentSubscriptionDetails, plan, activePlan }) => {
	const currentProfile = getCurrentSubscriptionProfile(currentSubscriptionDetails);
	const displayedProfile = getDisplayedPlanProfile(plan, activePlan);

	if (!currentProfile.family || !displayedProfile.family) return false;
	if (currentProfile.family !== displayedProfile.family) return false;

	if (
		currentProfile.billingCycle &&
		displayedProfile.billingCycle &&
		currentProfile.billingCycle !== displayedProfile.billingCycle
	) {
		return false;
	}

	if (currentProfile.family === 'studio' && currentProfile.seatCount && displayedProfile.seatCount) {
		return currentProfile.seatCount === displayedProfile.seatCount;
	}

	return true;
};
